var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('background',_vm._b({},'background',_vm.background,false),[_vm._t("inset",[(_vm.insetUrl)?_c('img',{class:['inset', (_vm.insetHorizontalAlign || '').toLowerCase()],attrs:{"src":_vm.insetUrl}}):_vm._e()]),_vm._v(" "),_vm._t("default",[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e6fac04","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/Content/Generic.vue
// module id = 286
// module chunks = 7 8 9